export default "<img class=\"icon\" [src]=\"iconSource\" />\n";